import { trustItems } from "./homeData";

export function TrustSection() {
  return (
    <section className="py-20 md:py-24">
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p className="overline mb-3">Security & compliance first</p>
        <h2 className="h-display text-3xl md:text-4xl">Built to the standards UK solicitors expect.</h2>
        <p className="mt-5 text-navy-600 max-w-2xl mx-auto">
          We hold your case data with the same gravity as you do. UK-hosted, encrypted, auditable, and tested against the SRA Code of Conduct.
        </p>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustItems.map((t) => (
            <div key={t.label} className="card-soft p-5 text-center">
              <t.icon className="w-6 h-6 text-emerald-600 mx-auto" strokeWidth={1.8} />
              <p className="mt-3 text-sm font-medium text-navy-900">{t.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
